import React from "react";
import { NavBar } from "../NavBar/NavBar";

function App1(props) {
  return (
    <div>
        <NavBar {...props} />
    </div>
  )
}

export default App1